import { render, staticRenderFns } from "./PendingForm.vue?vue&type=template&id=8f79f600&scoped=true&"
import script from "./PendingForm.vue?vue&type=script&lang=js&"
export * from "./PendingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f79f600",
  null
  
)

export default component.exports